import { Component, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export enum LoaderType {
    indefinite = 'indefinite',
    definite = 'definite',
}

@Component({
    standalone: true,
    imports: [CommonModule],
    selector: 'global-home-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent implements OnChanges {
    @Input() type: string = LoaderType.indefinite;
    @Input() label = '';
    @Input() public progress = 0;

    ringRadius = 16;
    ringStroke = 4;
    ringNormalizedRadius: number = this.ringRadius - (this.ringStroke - 2);
    ringCircumference: number = this.ringNormalizedRadius * 2 * Math.PI;
    ringOffset: number = this.ringCircumference - (this.progress / 100) * this.ringCircumference;

    setRingStyles() {
        const styles = {
            'stroke-dasharray': `${this.ringCircumference} ${this.ringCircumference}`,
            'stroke-dashoffset': this.ringOffset,
        };
        return styles;
    }

    ngOnChanges() {
        this.ringOffset = this.ringCircumference - (this.progress / 100) * this.ringCircumference;
    }
}
